import { render, staticRenderFns } from "./SanneStep.vue?vue&type=template&id=34659fde&scoped=true&"
import script from "./SanneStep.vue?vue&type=script&lang=js&"
export * from "./SanneStep.vue?vue&type=script&lang=js&"
import style0 from "./SanneStep.vue?vue&type=style&index=0&id=34659fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34659fde",
  null
  
)

export default component.exports